require('jquery-mask-plugin');
require('../../../../../vendor/jquery.payment.extended.js');
require('./credit-card-form/credit-card-form.scss');
var BaseViews = require('../../../base');

var CreditCardForm = BaseViews.LayoutView.extend({
    className: 'fmcy-credit-card-form',
    template: require('./credit-card-form/credit-card-form.html'),
    ui: {
        postalCodeInput: '#fmcy-credit-card-form-postal-code-field',
        nameInput: '#fmcy-credit-card-form-name-field',
        ccInput: '#fmcy-credit-card-form-cc-field',
        ccInputCardIcon: '.fmcy-cart-payment-field-credit-card-icon',
        ccExpiryInput: '#fmcy-credit-card-form-cc-expiry-field',
        ccSecurityInput: '#fmcy-credit-card-form-cc-security-field',
        alertMessage: '.fmcy-credit-card-form-alert-message',
        alertMessageText: '.alert-danger'
    },
    initialize: function (options) {
        var self = this;
        self.options = _.defaults(
            options || {},
            {
                autoFocusPrimaryField: false
            }
        );

        self.model.on('change:cc_card_type', function () {
          self._renderCCFieldIcon();
        });
    },
    validateVisitedFieldsOnly: true,
    modelEvents: function () {
        var self = this;
        return _.extend(
            {},
            _.result(BaseViews.LayoutView.prototype, 'modelEvents'),
            {
                validated: self.maybeDisplayValidationAlert.bind(self)
            }
        );
    },
    validatedFields: function () {
        var validatedFields = [
            'cc_name_on_card',
            'cc_number',
            'cc_expiry_date',
            'cc_security_code',
            'cc_postal_code'
        ];
        return validatedFields;
    },
    toggleValidationAlert: function (show) {
        if (show) {
            this.ui.alertMessage.removeClass('hidden');
            this.options._appChannel.request('scroll:to:page:top');
        } else {
            this.ui.alertMessage.addClass('hidden');
        }
    },
    maybeDisplayValidationAlert: function () {
        if (this.$el.find('.has-error').length) {
            this.toggleValidationAlert(true);
        } else {
            this.toggleValidationAlert(false);
        }
    },
    onModelAttributeValid: function (attr, selector) {
        if (BaseViews.LayoutView.prototype.onModelAttributeValid.call(this, attr, selector)) {
            this.maybeDisplayValidationAlert();
        }
    },
    onModelAttributeInvalid: function (attr, error, selector, hideAlertMessage) {
        if (BaseViews.LayoutView.prototype.onModelAttributeInvalid.call(this, attr, error, selector)) {
            if (!hideAlertMessage) {
              this.maybeDisplayValidationAlert();
            }
        }
    },
    bindings: function () {
        var options = {
            events: ['blur'],
            setOptions: {
                validate: true
            }
        };
        var bindings = {
            '[name=cc_name_on_card]':
                _.extend(
                    {},
                    options,
                    { observe: 'cc_name_on_card' }
                ),
            '[name=cc_number]':
                _.extend(
                    {},
                    options,
                    { observe: 'cc_number' }
                ),
            '[name=cc_expiry_date]':
                _.extend(
                    {},
                    options,
                    { observe: 'cc_expiry_date' }
                ),
            '[name=cc_security_code]':
                _.extend(
                    {},
                    options,
                    { observe: 'cc_security_code' }
                ),
            '[name=cc_postal_code]':
                _.extend(
                    {},
                    options,
                    { observe: 'cc_postal_code' }
                )
        };

        return bindings;
    },
    _renderCCFieldIcon: function () {
      var self = this;
      if (this.ui.ccInputCardIcon && typeof this.ui.ccInputCardIcon.removeClass === 'function') {
        this.ui.ccInputCardIcon.removeClass('visa-xs');
        this.ui.ccInputCardIcon.removeClass('amex-xs');
        this.ui.ccInputCardIcon.removeClass('discover-xs');
        this.ui.ccInputCardIcon.removeClass('mastercard-xs');
        if (this.model.get('cc_card_type') && typeof this.ui.ccInputCardIcon.addClass === 'function') {
          this.ui.ccInputCardIcon.addClass(self.model.get('cc_card_type') + '-xs');
        }
      }
    },
    events: function () {
        var self = this;

        function setVisited (ev) {
            self._setElementAsVisited($(ev.target));
        }

        function ccInputChanged () {
          self.prevCardType = self.cardType;
          self.cardType = $.payment.cardType(self.ui.ccInput.val());
          self.model.set('cc_card_type', self.cardType);
        }

        return {
            'blur input': setVisited,
            'keyup @ui.ccInput': ccInputChanged,
            'click select': setVisited
        };
    },
    serializeData: function () {
        return {
            options: this.options
        };
    },
    onRender: function () {
        var self = this;

        self.ui.ccInput.payment('formatCardNumber');
        self.ui.ccExpiryInput.payment('formatCardExpiry');
        self.ui.ccSecurityInput.payment('formatCardCVC');

        if (self.options.autoFocusPrimaryField) {
            setTimeout(function () {
                self.ui.nameInput.trigger('focus');
            }, 0);
        }

        if (this.options.errorField) {
          this.onModelAttributeInvalid(this.options.errorField, null, null, true);
        }

        this.listenTo(this.options._appChannel, 'cart:display:errors', function () {
          self.validateVisitedFieldsOnly = false;
          self.model.isValid(self.model.validationFields());
          self.validateVisitedFieldsOnly = true;
        });
        BaseViews.LayoutView.prototype.onRender.call(this);
    }
});
module.exports = CreditCardForm;



/** WEBPACK FOOTER **
 ** ./assets/js/common/cart/cart-payment/forms/credit-card-form.js
 **/